
import { DataTableHeader } from 'vuetify';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ShiftTypeRepositoryInterface, { ShiftTypeInterface } from '@/services/Calendar/ShiftType/Interfaces';
import { UserShiftInterface } from '@/services/Users/Interfaces';
import ShiftRepositoryInterface, {
  ShiftInterface, ShiftStatisticMapInterface,
  ShiftStatisticsWSInterface,
} from '@/services/Calendar/Shifts/Interfaces';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import Themeable from 'vuetify/lib/mixins/themeable';
import { EventsInterface, EventType } from '@/services/Calendar/Events/Interfaces';
import EventsRepository from '@/services/Calendar/Events';
import ShiftTeamRepository from '@/services/Calendar/ShiftTeam';

@Component({
  mixins: [Themeable],
  inject: [
    'profileRepository',
    'shiftRepository',
    'shiftTeamRepository',
    'shiftTypeRepository',
    'eventsRepository',
  ],
  sockets: {
    async shiftStatisticData(msg: ShiftStatisticsWSInterface): Promise<void> {
      // @ts-ignore
      this.handleShiftStatisticData(msg);
    },
  },
})
export default class ShiftsComponent extends Vue {
  private readonly profileRepository!: ProfileRepositoryInterface;
  private readonly shiftRepository!: ShiftRepositoryInterface;
  private readonly shiftTeamRepository!: ShiftTeamRepository;
  private readonly shiftTypeRepository!: ShiftTypeRepositoryInterface;
  private readonly eventsRepository!: EventsRepository;

  @Prop() private currentMonth: string;
  @Prop() private selectedDates: string[];
  private loading: boolean = true;
  private headers: DataTableHeader[] = [];
  private date: string = new Date(this.currentMonth).toISOString().substr(0, 7);
  private selectedYear: number = Number(this.date.substr(0, 4));
  private selectedMonth: number = Number(this.date.substr(5, 2));
  private daysOfTheMonth: number = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
  private holidays: Map<number, EventsInterface> = new Map();
  private shiftTypes: ShiftTypeInterface[] = [];
  private unsortedUsers: UserShiftInterface[] = [];
  private userStatistics: Map<string, ShiftStatisticMapInterface> = new Map();
  private shiftTableCounter: number = 0;
  private initialShifts: any = {};

  private async mounted(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void> {
    this.date = new Date(this.currentMonth).toISOString().substr(0, 7);
    this.selectedYear = Number(this.date.substr(0, 4));
    this.selectedMonth = Number(this.date.substr(5, 2));
    this.daysOfTheMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    this.holidays = new Map();
    const holidays = await this.eventsRepository.getEventsForMonth(this.selectedYear, this.selectedMonth);
    holidays.forEach((holiday) => {
      console.log(holiday.name);
      if (Number(holiday.type) === EventType.national) {
        holiday.date = new Date(holiday.date);
        this.holidays.set(holiday.date.getDate(), holiday)
      }
    });
    this.getHeaders();
    this.shiftTypes = await this.shiftTypeRepository.getAllShiftTypes();

    await this.initializeUser();

    this.loading = false;
  }

  @Watch('currentMonth')
  private async changedMonth(): Promise<void> {
    this.loading = true;
    this.unsortedUsers[0].shifts = [];
    console.log(this);
    await this.init();
  }

  @Watch('selectedDates')
  private selectedDutyDay(): void {
    const filtered: { [date: string]: ShiftInterface } = {};
    Object.keys(this.initialShifts).forEach((key) => {
      if (!this.selectedDates.includes(key)) {
        filtered[key] = this.initialShifts[key] as ShiftInterface;
      }
    });

    this.unsortedUsers[0].shifts = filtered;
  }

  private async initializeUser(): Promise<void> {
    await this.shiftTeamRepository
      .getUserShiftStatistics(this.$store.getters.id, new Date(this.selectedYear, this.selectedMonth));
    const defaultStatistics = { standardWorkingHours: 0, actualWorkingHours: 0, overtime: 0 }
    const user = await this.profileRepository.getOneByUserId(this.$store.getters.id);
    const uShifts: UserShiftInterface = {
      id: this.$store.getters.id,
      username: this.$store.getters.username,
      department: this.$store.getters.departmentId,
      shifts: await this.getUserShifts(user.userId),
      details: {
        firstName: user.personalDetails.firstName,
        lastName: user.personalDetails.lastName,
      },
    } as UserShiftInterface;

    this.initialShifts = uShifts.shifts;
    this.unsortedUsers = [uShifts];

    this.userStatistics.set(user.userId, {
      currentMonth: defaultStatistics,
      currentQuarter: defaultStatistics,
      year: defaultStatistics,
    });
  }

  private async getUserShifts(userId: string): Promise<any> {
    const shifts: { [key: string]: ShiftInterface } = {};
    const userShifts = await this.shiftRepository.getUserShifts(userId, new Date(this.currentMonth));
    userShifts.map((shift) => {
      shifts[(new Date(shift.date)).toISOString().slice(0, 10)] = shift;
    });

    return shifts;
  }

  private getHeaders(): void {
    const headers: DataTableHeader[] = [
      { text: 'Name', value: 'name', sortable: false },
    ];

    for (let i = 1; i <= this.daysOfTheMonth; i++) {
      const dayOfWeek = this.dayOfWeek(i);
      const holiday = this.holidays.get(i);
      let typeOfDay = 'rest';

      if (dayOfWeek !== 'Saturday' && dayOfWeek !== 'Sunday') {
        typeOfDay = 'work';
      }

      if (holiday) {
        typeOfDay = 'holiday';

        if (dayOfWeek === 'Saturday' || dayOfWeek === 'Sunday') {
          typeOfDay += ' weekend';
        }
      }

      headers.push({
        text: String(i),
        value: `${this.selectedYear}-${('0' + this.selectedMonth).slice(-2)}-${('0' + i).slice(-2)}`,
        sortable: false,
        class: typeOfDay + ' px-0',
      });
    }

    headers.push(
      { text: 'Standard Working Hours', value: 'swh', sortable: false, class: ' px-0' },
      { text: 'Actual Working Hours', value: 'awh', sortable: false, class: ' px-0' },
      { text: 'Overtime', value: 'ot', sortable: false, class: ' px-0' },
      { text: 'Overtime For The Trimester', value: 'ot3', sortable: false, class: ' px-0' },
      { text: 'Overtime For The Year ', value: 'otty', sortable: false, class: ' px-0' },
    );

    this.headers = headers;
  }

  private dayOfWeek(day: number): string {
    const date = new Date(`${this.selectedYear}-${this.selectedMonth}-${day}`);
    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    return weekday[date.getDay()];
  }

  private getHolidayInfo(day: number): string {
    const holiday = this.holidays.get(day);
    const dayOfWeek = this.dayOfWeek(day);

    if (holiday) {
      return `<b>${holiday.name}</b><br />${dayOfWeek}`;
    }

    return dayOfWeek;
  }

  private async handleShiftStatisticData(statistics: ShiftStatisticsWSInterface): Promise<void>  {
    await this.sleep(50);
    this.userStatistics.set(statistics.userId, {
      currentMonth: statistics.currentMonth,
      currentQuarter: statistics.currentQuarter,
      year: statistics.year,
    });
    this.shiftTableCounter += 1;
  }

  private getDurationHoursForDate(date: string): number {
    const shift = (this.initialShifts?.[date] ?? this.unsortedUsers?.[0]?.shifts?.[date]) as ShiftInterface | undefined;

    const type = (shift as any)?.shiftType as ShiftTypeInterface;
    const duration = Number(type?.duration);
    if (Number.isFinite(duration)) {
      return duration;
    }

    // Fallback - normal working day
    return 8;
  }

  private get selectionSummary(): string {
    const dates = this.selectedDates?.slice().sort() ?? [];
    if (!dates.length) return '';

    const hours = dates.reduce((sum, date) => sum + this.getDurationHoursForDate(date), 0);
    const days = hours / 8;

    const h = Number.isInteger(hours) ? hours : hours.toFixed(2);
    const dy = Number.isInteger(days) ? days : days.toFixed(2);

    return `${new Date(dates[0]).toDateString()} – ${new Date(dates[dates.length - 1]).toDateString()} • ${dates.length} • ${h}h • ${dy} day(s)`;
  }


  private sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
